/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegionsControllerFindOneQueryResponse, RegionsControllerFindOnePathParams, RegionsControllerFindOneQueryParams, RegionsControllerFindOne400, RegionsControllerFindOne401, RegionsControllerFindOne403, RegionsControllerFindOne404 } from "../../models/regionsController/RegionsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { regionsControllerFindOne } from "../../clients/regionsService/regionsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const regionsControllerFindOneQueryKey = (id: RegionsControllerFindOnePathParams["id"], params: RegionsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/regions/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type RegionsControllerFindOneQueryKey = ReturnType<typeof regionsControllerFindOneQueryKey>;
export function regionsControllerFindOneQueryOptions(id: RegionsControllerFindOnePathParams["id"], params?: RegionsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = regionsControllerFindOneQueryKey(id, params);
  return queryOptions<RegionsControllerFindOneQueryResponse, ResponseErrorConfig<RegionsControllerFindOne400 | RegionsControllerFindOne401 | RegionsControllerFindOne403 | RegionsControllerFindOne404>, RegionsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return regionsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a region by ID
 * {@link /api/v1/regions/:id}
 */
export function useRegionsControllerFindOne<TData = RegionsControllerFindOneQueryResponse, TQueryData = RegionsControllerFindOneQueryResponse, TQueryKey extends QueryKey = RegionsControllerFindOneQueryKey>(id: RegionsControllerFindOnePathParams["id"], params?: RegionsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<RegionsControllerFindOneQueryResponse, ResponseErrorConfig<RegionsControllerFindOne400 | RegionsControllerFindOne401 | RegionsControllerFindOne403 | RegionsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? regionsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...regionsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<RegionsControllerFindOne400 | RegionsControllerFindOne401 | RegionsControllerFindOne403 | RegionsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}